import {
  createRouter,
  createWebHistory,
  START_LOCATION
} from 'vue-router'
import { logAnalyticsEvent } from '@/assets/js/firebase'
import { ensureDeviceId } from '@/assets/js/device'

/** Tab 曝光事件，与 iOS MainBottomTabController 对齐 */
const TAB_SHOW_EVENTS = {
  '/home': 'home_show',
  '/video': 'feed_show',
  '/record': 'my_list_show',
  '/reward': 'reward_show',
  '/mine': 'me_show'
}
const Home = () => import('@/views/Home'/* webpackChunkName: "home" */)
const Record = () => import('@/views/Record'/* webpackChunkName: "record" */)
const Video = () => import('@/views/Video'/* webpackChunkName: "video" */)
const Reward = () => import('@/views/Reward'/* webpackChunkName: "reward" */)
const Mine = () => import('@/views/Mine'/* webpackChunkName: "mine" */)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { showTab: true }
  },
  {
    path: '/record',
    component: Record,
    meta: { showTab: true }
  },
  {
    path: '/video',
    component: Video,
    meta: { showTab: true }
  },
  {
    path: '/reward',
    component: Reward,
    meta: { showTab: true }
  },
  {
    path: '/mine',
    component: Mine,
    meta: { showTab: true }
  },
  { path: '/mybill', name: 'mybill', component: () => import('@/views/mine/MyBill.vue') },
  { path: '/feedback', name: 'feedback', component: () => import('@/views/mine/Feedback.vue') },
  { path: '/privacy_policy', name: 'privacy_policy', component: () => import('@/views/mine/PrivacyPolicy.vue') },
  { path: '/user_agreement', name: 'user_agreement', component: () => import('@/views/mine/UserAgreement.vue') },
  { path: '/category', name: 'category', component: () => import('@/views/Category.vue') },
  { path: '/discovery/:groupId', name: 'discovery_playlist', component: () => import('@/views/DiscoveryPlaylist.vue') },
  { path: '/play/:id', name: 'play', component: () => import('@/views/Play.vue') },
  { path: '/search', name: 'search', component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue') },
  { path: '/login', name: 'login', component: () => import('@/views/mine/Login.vue') },
  { path: '/login/cognito/callback', name: 'cognito_callback', component: () => import('@/views/mine/CognitoCallback.vue') },
  { path: '/pay/callback', name: 'pay_callback', component: () => import('@/views/PayCallback.vue') },
  { path: '/topup', name: 'topup', component: () => import('@/views/TopUp.vue') }
]

if (process.env.NODE_ENV !== 'production') {
  routes.push({
    path: '/test-list',
    name: 'test_list',
    component: () => import(/* webpackChunkName: "test-list" */ '@/views/TestList.vue')
  })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  const deviceId = await ensureDeviceId()
  if (!deviceId || to.query.deviceId === deviceId) return true

  return {
    path: to.path,
    query: {
      ...to.query,
      deviceId
    },
    hash: to.hash,
    // 首次加载只补齐当前 URL；内部导航沿用原始 push/replace 语义。
    ...(from === START_LOCATION ? { replace: true } : {})
  }
})

router.afterEach((to, from) => {
  // 返回拦截占位的 pushState/back 会触发一次「原地导航」（fullPath 未变），
  // 跳过以避免重复上报 tab 曝光。
  if (to.fullPath === from.fullPath) return

  const eventName = TAB_SHOW_EVENTS[to.path]
  if (eventName) {
    const params = eventName === 'home_show'
      ? { entry: typeof to.query.entry === 'string' ? to.query.entry : 'default' }
      : {}
    logAnalyticsEvent(eventName, params)
  }

  if (to.path === '/home' && to.query.entry && typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    url.searchParams.delete('entry')
    window.history.replaceState(window.history.state, '', url)
  }
})

export default router
